export default function reducer(state = {
    feedback_enable: false,
    feedback_questions: [],
    showPopup: false
}, action) {
    switch (action.type) {
        case "STORE_FEEDBACK_QUESTIONS": {
            return { ...state,
                feedback_enable: action.data.show,
                feedback_questions: action.data.questions
            }
        }
        case "SHOW_FEEDBACK_POPUP": {
            return { ...state,
                showPopup: action.bool
            }
        }
        default:
            break;
    }
    return state;
}
